const firebaseConfig = {
	apiKey: 'AIzaSyDPCzERUQwfWUSnOMxfKN_l1JI8B5jvPl0',
	authDomain: 'web-a2bf7.firebaseapp.com',
	projectId: 'web-a2bf7',
	storageBucket: 'web-a2bf7.appspot.com"',
	messagingSenderId: '780267482533',
	appId: '1:780267482533:web:e507793b763ec8c9bf0c4c',
	measurementId: 'G-180ZCK8Q70',
}

export default firebaseConfig
